var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.375C11.5298 9.375 11.25 9.65482 11.25 10C11.25 10.3452 11.5298 10.625 11.875 10.625C12.2202 10.625 12.5 10.3452 12.5 10C12.5 9.65482 12.2202 9.375 11.875 9.375Z",
    fill: "#070A26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 16.25V13.125C18.4702 13.125 18.75 12.8452 18.75 12.5V7.5C18.75 7.15482 18.4702 6.875 18.125 6.875V3.75C18.125 3.40482 17.8452 3.125 17.5 3.125H1.875C1.52982 3.125 1.25 3.40482 1.25 3.75V16.25C1.25 16.5952 1.52982 16.875 1.875 16.875H17.5C17.8452 16.875 18.125 16.5952 18.125 16.25ZM2.8125 15.3125V4.6875H16.5625V6.875H11.875C10.1491 6.875 8.75 8.27411 8.75 10C8.75 11.7259 10.1491 13.125 11.875 13.125H16.5625V15.3125H2.8125ZM17.1875 8.4375H11.875C11.0121 8.4375 10.3125 9.13706 10.3125 10C10.3125 10.8629 11.0121 11.5625 11.875 11.5625H17.1875V8.4375Z",
    fill: "#070A26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.fed7d6dfcb27f7818d7423a3fb9279ea.svg";
export { ForwardRef as ReactComponent };